import { makesQueries } from 'data/graphql'
import gql from 'graphql-tag'
import { connect } from 'react-redux'
import { compose } from 'recompose'

import {
  viewIsLoading,
  viewHasLoaded,
  viewFailedToLoad,
} from 'data/ui/viewState'

const noop = () => {}

const getApplicationShareSettingsQuery = gql`
  fragment ShareTargetAttrs on ShareTarget {
    id
    type
    label
    subLabel
    required
    autofocus
    initialValue
  }

  fragment ShareValueOptionAttrs on ShareValueOption {
    label
    subLabel
    metadata
    value
  }

  fragment ShareTargetRecursive on ShareTarget {
    ...ShareTargetAttrs
    options {
      ...ShareValueOptionAttrs
      children {
        ...ShareTargetAttrs
        options {
          ...ShareValueOptionAttrs
          children {
            ...ShareTargetAttrs
            options {
              ...ShareValueOptionAttrs
              children {
                ...ShareTargetAttrs
                options {
                  ...ShareValueOptionAttrs
                  children {
                    ...ShareTargetAttrs
                  }
                }
              }
            }
          }
        }
      }
    }
  }
  query getApplicationShareSettings(
    $clientId: ID!
    $noteId: ID!
    $selectedText: String
  ) {
    getApplicationShareSettings(
      clientId: $clientId
      noteId: $noteId
      selectedText: $selectedText
    ) {
      needsUserAssociation {
        redirectUrl
      }
      targets {
        ...ShareTargetRecursive
      }
    }
  }
`

// `required` has `true` as default value on ShareTarget to simplify the application's dev.
// Let's set that default value here to avoid having to deal with it in other places.
function setDefaultRequiredValue(target) {
  const { options } = target

  return {
    ...target,
    required: target.required === null ? true : target.required,
    // required: true,
    options:
      options &&
      options.map(option => {
        return {
          ...option,
          children: option.children
            ? option.children.map(setDefaultRequiredValue)
            : null,
        }
      }),
  }
}

export default function withGetApplicationShareSettings({
  viewName = 'loadShareSettings',
  onShareSettingsFetched = noop,
  mapPropsToVariables = ({ clientId, noteId, selectedText }) => ({
    clientId,
    noteId,
    selectedText,
  }),
  queryOnChanges,
}) {
  return compose(
    connect(
      null,
      { viewIsLoading, viewHasLoaded, viewFailedToLoad }
    ),
    makesQueries({
      query: getApplicationShareSettingsQuery,
      queryOnChanges,
      mapPropsToVariables,
      getOnQueryFromProps: ({ viewIsLoading }) => () =>
        viewIsLoading(viewName, ''),
      getOnResultFromProps: props => ({ result }) => {
        const data = result.data.getApplicationShareSettings
        // @ts-ignore
        onShareSettingsFetched(props, {
          ...data,
          targets: data.targets && data.targets.map(setDefaultRequiredValue),
        })

        props.viewHasLoaded(viewName, '')
      },
      getOnErrorFromProps: ({ viewFailedToLoad }) => ({ error }) =>
        viewFailedToLoad(viewName, '', error),
    })
  )
}
